import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-053249f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dw-record-popup" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "dw-record-popup__anchor",
  width: "16",
  height: "8",
  viewBox: "0 0 16 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16 8L8 8L0 8L6.58579 1.41421C7.36684 0.633163 8.63316 0.633165 9.41421 1.41421L16 8Z",
    fill: "white"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_record_popup_feature = _resolveComponent("dw-record-popup-feature")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_dw_record_popup_feature, {
      feature: _ctx.feature,
      onClose: _ctx.onClose,
      onChangeDate: _ctx.onChangeDate,
      onAddToWaitList: _ctx.onAddToWaitList,
      onAssign: _ctx.onAssign,
      onSelfDelivery: _ctx.onSelfDelivery
    }, null, 8, ["feature", "onClose", "onChangeDate", "onAddToWaitList", "onAssign", "onSelfDelivery"])
  ]))
}